module.exports = __webpack_public_path__ + "img/home-budget-dark.42133b1c.png";